/* eslint-disable @typescript-eslint/no-explicit-any */
import { run as runActions } from '../../../../../store/workspaces/workspaces/run';

export const commandClick = (params: any, e: any, data: any): void => {
  const {
    key,
    id,
    modifiers
  } = params;

  if (!key) return null;

  window.dispatchEvent(
    new CustomEvent(
      'custom-mousedown',
      {
        detail: {
          key: key,
          id: id,
          modifiers: modifiers,
          event: e
        }
      }
    )
  );
  if(!e.ctrlKey && !modifiers?.ctrl && !modifiers?.alt && !modifiers?.shift){
    runActions(key, id, { data });
  }
};